export default __webpack_public_path__ + "static/inter-400.latin-0b9a4767f018fce446047ffe473f93e2.woff2";